import { BdbSessionStrgService } from "@npm-bbta/bbog-cm-auth-lib";
import { IAssitedStorage, IAssitedStorageKeys } from "./models/IAssitedStorage";
import { Injectable } from "@angular/core";

@Injectable()
export class AssistedStorage implements IAssitedStorage {

    PRINCIPAL_KEY = 'assisted';

    constructor(
        private readonly bdbSessionStorageService: BdbSessionStrgService
    ){
    }

    public async deleteByKey(principalKey: string, value: any,  secondKey?: string){
        let keyForDelete;
        const principalSting = this.bdbSessionStorageService.get(this.PRINCIPAL_KEY);
        const assisted = JSON.parse(principalSting);
        keyForDelete = assisted[principalKey]
        if(secondKey){
            keyForDelete = keyForDelete[secondKey];
        }
        this.bdbSessionStorageService.delete(keyForDelete);
    }

    public async deleteAll(){
        const key = this.bdbSessionStorageService.get(this.PRINCIPAL_KEY);
        this.bdbSessionStorageService.delete(key);
    }

    public async saveByKey(principalKey: string, value: any,  secondKey?: string) {
        let keyForSave;
        const principalSting = this.bdbSessionStorageService.get(this.PRINCIPAL_KEY);
        const assisted = JSON.parse(principalSting);
        keyForSave = assisted[principalKey]
        if(secondKey){
            keyForSave = keyForSave[secondKey];
        }
        this.bdbSessionStorageService.save(keyForSave, JSON.stringify(value));
    }

    public async saveAll(value: IAssitedStorageKeys){
        const valueString = JSON.stringify(value);
        this.bdbSessionStorageService.save(this.PRINCIPAL_KEY, valueString);
    }

    public async getByKey(key: string){
        const assistedString = this.bdbSessionStorageService.get(this.PRINCIPAL_KEY);
        const assisted = JSON.parse(assistedString);
        return assisted[key];
    }

    public async getAll(){
       return JSON.parse(this.bdbSessionStorageService.get(this.PRINCIPAL_KEY));
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/assistedStorage/assistedStorage.ts